module.exports = __webpack_public_path__ + "assets/img/free_12.dd24cc15.png";